import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router, RouterLink } from '@angular/router';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from '@services/auth';
import { NotificationsService } from '@services/notifications.service';
import { I18NextPipe } from 'angular-i18next';
import { distinctUntilChanged, map } from 'rxjs';

interface NavItem {
  labelKey: string;
  route: string;
}

@Component({
  selector: 'mbs-reseller-nav',
  templateUrl: './nav.component.html',
  styleUrls: ['./nav.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, RouterLink, NgbDropdownModule, I18NextPipe]
})
export class NavComponent {
  protected auth = inject(AuthService);
  protected notificationsService = inject(NotificationsService);
  private router = inject(Router);

  private activatedUrl = toSignal(
    this.router.events.pipe(
      map((event) => ((event as any)?.url || '').split('?')[0]),
      distinctUntilChanged()
    )
  );

  protected readonly navItems: NavItem[] = [
    { labelKey: 'nav.myProfile', route: '/AP/ParthnersProfile.aspx' },
    { labelKey: 'nav.storage', route: '/AP/EditAccount.aspx' },
    { labelKey: 'nav.myCustomers', route: '/AP/ProviderList.aspx' },
    { labelKey: 'nav.myLicenses', route: '/AP/PartnerLicenses.aspx' },
    { labelKey: 'nav.licenseUsage', route: '/AP/LicenseUsage.aspx' },
    { labelKey: 'nav.purchaseHistory', route: '/AP/PurchaseHistory' },
    { labelKey: 'nav.help', route: '/AP/Help.aspx' }
  ];

  handleLogout(): void {
    this.router.navigateByUrl(this.auth.logoutUrlTree(this.router));
  }

  protected isActiveMenuItem(menuItem: NavItem): boolean {
    const result = !!menuItem && this.isActiveRoute(menuItem.route);

    return result ? true : result;
  }

  private isActiveRoute(route: string): boolean {
    const activatedUrl = this.activatedUrl();

    return !!activatedUrl && !!route && (activatedUrl === route || activatedUrl.startsWith(route + '/'));
  }
}
